var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "add_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.formParam.id != "" && _vm.formParam.id != null
                ? _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("\n          Edit Product\n        ")
                  ])
                : _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Add Product")
                  ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  id: "ajax",
                                  label: "brand_name",
                                  "track-by": "id",
                                  placeholder: "Type to search Brand...",
                                  multiple: true,
                                  "open-direction": "bottom",
                                  "custom-label": _vm.customLabel,
                                  options: _vm.contactOptions,
                                  searchable: true,
                                  loading: _vm.isLoading,
                                  "internal-search": false,
                                  "close-on-select": false,
                                  "options-limit": 300,
                                  limit: 3,
                                  "limit-text": _vm.limitText,
                                  "max-height": 600,
                                  "show-no-results": true,
                                  "hide-selected": true,
                                  "show-labels": false
                                },
                                on: { "search-change": _vm.asyncFind },
                                scopedSlots: _vm._u([
                                  {
                                    key: "tag",
                                    fn: function(ref) {
                                      var option = ref.option
                                      var remove = ref.remove
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "custom__tag" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(option.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "custom__remove",
                                                on: {
                                                  click: function($event) {
                                                    return remove(option)
                                                  }
                                                }
                                              },
                                              [_vm._v("❌")]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "clear",
                                    fn: function(props) {
                                      return [
                                        _vm.selectedContact.length
                                          ? _c("div", {
                                              staticClass: "multiselect__clear",
                                              on: {
                                                mousedown: function($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.clearAll(
                                                    props.search
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.selectedContact,
                                  callback: function($$v) {
                                    _vm.selectedContact = $$v
                                  },
                                  expression: "selectedContact"
                                }
                              },
                              [
                                _vm._v(" "),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult"
                                  },
                                  [_vm._v("Oops! No elements found.")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formParam.name,
                              expression: "formParam.name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", required: "" },
                          domProps: { value: _vm.formParam.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formParam,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Description:")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "message-bar" }, [
                              _c("div", { staticClass: "message-inner" }, [
                                _c("div", { staticClass: "message-area" }, [
                                  _c(
                                    "div",
                                    { staticClass: "input-group m-b-30" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formParam.description,
                                            expression: "formParam.description"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.formParam.description
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formParam,
                                              "description",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm.isSending == false
                          ? _c("center", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveForm(0)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-check" }),
                                  _vm._v(" Save\n                  ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md btn-info",
                                  style: "margin-left:10px;",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.saveForm(1)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-check" }),
                                  _vm._v(" Save & Exit\n                  ")
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("\n                    Brand:\n                    "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("\n                    Name:\n                    "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc90e9bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc90e9bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/products/form.vue
// module id = null
// module chunks = 